module.exports = __webpack_public_path__ + "static/media/glasses.d4f6ad01.svg";